export default {
  methods: {
    clickQuizButtonHandler (qmId) {
      this.$emit('clickQuizButton', {
        qmId
      })
    }
  }
}
